import { withStyles } from '@material-ui/core';
import Star from '@material-ui/icons/Star';

export const FavoriteFilled = withStyles(theme => ({
  root: {
    color: theme.palette.favs,
  },
}))(Star);
